import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import SubCard from "ui-component/cards/SubCard";
import {
  Button,
  TextField,
  Box,
  Typography,
  Grid,
  Card,
  // CardContent,
  Tooltip,
  Stack,

} from "@mui/material";
import * as XLSX from "xlsx";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useEffect } from "react";
import SnackBar from "../../General/SnackBar";
import BackdropLoader from "../../General/Loader";
// import { GetPurchaseOrder } from "API/PurchaseOrder/api";
import PurchaseOrderDialog from "./PurchaseOrderModal";
import PaymentOrderDialog from "./PaymentOrderDialog";
import { GetPaymentOrders } from "API/PaymentOrder/api";
import CompletePaymentDialog from "./CompletePaymentDialog";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { GetAllDevice } from "API/PurchaseRequest/api";
import { GetUserRole } from "API/Misc/MakerChecker";
import RemarksDialog from "./RemarksDialog";

function formatDate(dateString) {
  const date = new Date(dateString);

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const formattedDate = `${day}-${month}-${year}`;
  return `${formattedDate}`;
}


// const CalculateAmount = (params) => {

//   console.log("params", params);


//   const totalAmount =
//     params.total.quantity && Array.isArray(params.total.quantity)
//       ? params.total.quantity.reduce((sum, item) => {
//         if (item.price) {
//           return parseFloat((sum + item.price) * 1.00);
//         }
//         return parseFloat(sum * 1.00);
//       }, 0)
//       : 0;

//   console.log("totalAmount ", totalAmount);
//   return (
//     <Typography variant="body1">
//       <table>
//         <tbody>
//           <tr>
//             {
//               params.total.purchase_order_details && params.total.purchase_order_details.tax_type === "interstate" ?
//                 <td>₹{(((totalAmount + parseInt(params.total.updated_tax.igst) + Number.EPSILON) * 100) / 100).toFixed(2)}</td>
//                 :
//                 <td>₹{(((totalAmount + parseInt(params.total.updated_tax.cgst) + parseInt(params.total.updated_tax.sgst) + Number.EPSILON) * 100) / 100).toFixed(2)}</td>

//             }
//           </tr>
//         </tbody>
//       </table>
//     </Typography>
//   );
// };



// const CalculateBalanceAmount = (params) => {

//   console.log("params", params);


//   const totalAmount =
//     params.total.quantity && Array.isArray(params.total.quantity)
//       ? params.total.quantity.reduce((sum, item) => {
//         if (item.price) {
//           return parseFloat((sum + item.price) * 1.00);
//         }
//         return parseFloat(sum * 1.00);
//       }, 0)
//       : 0;

//   // console.log("totalBalance ",(eval(params.total.purchase_order_details.sub_total + parseInt(params.total.purchase_order_details.tax.igst))));
//   return (
//     <Typography variant="body1">
//       <table>
//         <tbody>
//           <tr>
//             {
//               params.total && params.total.purchase_order_details?
//                 params.total.purchase_order_details && params.total.purchase_order_details.tax_type === "interstate" ?
//                   <td>₹{(((eval(params.total.purchase_order_details.sub_total + parseInt(params.total.purchase_order_details.tax.igst)) - (totalAmount + parseInt(params.total.updated_tax.igst)) + Number.EPSILON) * 100) / 100).toFixed(2)}</td>
//                     :
//                   <td>₹{(((eval(params.total.purchase_order_details.sub_total + parseInt(params.total.purchase_order_details.tax.cgst+params.total.purchase_order_details.tax.sgst))-(totalAmount + parseInt(params.total.updated_tax.cgst) + parseInt(params.total.updated_tax.sgst) + Number.EPSILON) * 100)) / 100).toFixed(2)}</td>
//                   :
//                   "0.00"

//             }
//           </tr>
//         </tbody>
//       </table>
//     </Typography>
//   );
// };

// const GetBalanceAmount=(params)=>{
//   const totalAmount =
//   params.quantity && Array.isArray(params.quantity)
//     ? params.quantity.reduce((sum, item) => {
//         if (item.price) {
//           return parseFloat((sum + item.price)*1.00);
//         }
//         return parseFloat(sum*1.00);
//       }, 0)
//     : 0;

//     return params.purchase_order_details&&params.purchase_order_details.tax_type==="interstate"?
//     (((eval(params.purchase_order_details.sub_total+parseInt(params.purchase_order_details.tax.igst))-totalAmount+parseInt(params.updated_tax.igst) + Number.EPSILON) * 100) / 100).toFixed(2)
//     :
//     (((totalAmount+parseInt(params.updated_tax.cgst)+parseInt(params.updated_tax.sgst) + Number.EPSILON) * 100) / 100).toFixed(2)
// }


// const GetTotalAmount = ( params ) => {
      
//   console.log("params",params);
  
      
//     const totalAmount =
//     params.quantity && Array.isArray(params.quantity)
//       ? params.quantity.reduce((sum, item) => {
//           if (item.price) {
//             return parseFloat((sum + item.price)*1.00);
//           }
//           return parseFloat(sum*1.00);
//         }, 0)
//       : 0;
    
//           console.log("totalAmount ",totalAmount);
//       return  params.purchase_order_details&&params.purchase_order_details.tax_type==="interstate"?(((totalAmount+parseInt(params.updated_tax.igst) + Number.EPSILON) * 100) / 100).toFixed(2)
//                   :
//                   (((totalAmount+parseInt(params.updated_tax.cgst)+parseInt(params.total.updated_tax.sgst) + Number.EPSILON) * 100) / 100).toFixed(2)
  
               
//     };

const columns = (handleViewPO, handlePaymentOrderOpen, handleOpenCompletePaymentDialog,actionFilter,handleOpenPaymentView,handleRemarksOpen) => [
  { field: "payment_order_id", headerName: "Payment Order Number", flex: 2, minWidth: 200 },
  {
    field: "_id",
    headerName: "Purchase Order No",
    flex: 2,
    minWidth: 200,
    renderCell: (params) => (
      <table>
        {
          
           
            
            <tr>{params.row.purchase_order_details?.purchase_order_id}</tr>
        }
      </table>
    )
  },
  {
    field: "date",
    headerName: "Date",
    flex: 1,
    minWidth: 150,
    renderCell: (params) => (
      <Typography>{params.row ? formatDate(params.row.created_at) : ''}</Typography>
    )
  },
  {
    field: "brand",
    headerName: "Brand Name",
    flex: 1,
    minWidth: 150,
    renderCell: (params) => (
      <table>{
        params.row.purchase_request_details && params.row.purchase_request_details ?
          params.row.purchase_request_details.map((item, index) => (
            <tr key={index}>{item.device_details.brand_name}</tr>
          ))

          :
          <tr></tr>


      }
      </table>
    )
  },
  {
    field: "device",
    headerName: "Device Name",
    flex: 1,
    minWidth: 150,
    renderCell: (params) => (
      <table>{
        params.row.purchase_request_details && params.row.purchase_request_details ?
          params.row.purchase_request_details.map((item, index) => (
            <tr key={index}>{item.device_details.name}</tr>
          ))

          :
          <tr></tr>


      }
      </table>
    )
  },
  {
    field: "modelnumber",
    headerName: "Model Number",
    flex: 1,
    minWidth: 150,
    renderCell: (params) => (
      <table>{
        params.row.purchase_request_details && params.row.purchase_request_details ?
          params.row.purchase_request_details.map((item, index) => (
            <tr key={index}>{item.device_details.model}</tr>
          ))

          :
          <tr></tr>


      }
      </table>
    )
  },

  {
    field: "quantity",
    headerName: "Quantity",
    flex: 1,
    minWidth: 100,
    renderCell: (params) => (
      <table>{params.row.quantity && Array.isArray(params.row.quantity) ?
        params.row.quantity.map((item, index) => (
          item.quantity ?
            <tr key={index}>{item.quantity}</tr>
            :
            <tr key={index}></tr>
        ))
        :
        null
      }
      </table>
    )
  },

  {
    field: "vendor",
    headerName: "Vendor Name",
    flex: 1,
    minWidth: 150,
    renderCell: (params) => (
      <Typography>{params.row.purchase_order_details && params.row.purchase_order_details.vendor_details ? params.row.purchase_order_details.vendor_details.vendor_name : ''}</Typography>
    )
  },

  {
    field: "total_amount",
    headerName: "Total amount",
    flex: 1,
    minWidth: 150,
    renderCell: (params) => (
      <Typography>{params.row && params.row.total_amount ? params.row.total_amount : params.row.total_price?params.row.total_price:""}</Typography>
    )


  },

  {
    field: "poadueamount",
    headerName: "PO Due Amount",
    flex: 1,
    minWidth: 150,
    renderCell: (params) => (
      <Typography>₹{params.row.due_amount}</Typography>
    )
  },
  { field: "payment_status", headerName: "Status", flex: 1, minWidth: 120 },
  {
    field: "view",
    headerName: "View",
    flex: 1,
    minWidth: 200,
    renderCell: (params) => (
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Tooltip title="View Purchase Order Details">
          <Stack gap={1}>
            <Button
              variant="contained"
              color="secondary"
              size="small"
              onClick={() => handleViewPO(params.row, 'write')}
            >
              Purchase Order
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => handlePaymentOrderOpen(params.row, 'write')}
            >
              Payment Order
            </Button>
          </Stack>
        </Tooltip>
      </Box>
    ),
  },
  {
    field: "action",
    headerName: "Action",
    flex: 1,
    minWidth: 200,
    renderCell: (params) => (
      <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Stack gap={1}>
            <Button
              disableFocusRipple
              variant="contained"
              color={actionFilter==='Pending' || (params.row.payment_status==="pending")?"secondary":"success"}
              size="small"
              // disabled={actionFilter==='Pending'?false:true}
              onClick={() =>actionFilter==='Pending' || (params.row.payment_status==="pending")? handleOpenCompletePaymentDialog(params.row):null}
              
            >
              {actionFilter==='Pending' || (params.row.payment_status==="pending")?"Complete Payment":"Payment Completed"}
            </Button>
            <Button
              disableFocusRipple
              variant="outlined"
              color="primary"
              size="small"
              sx={{ display: "none" }}
              onClick={() => handleOpenCompletePaymentDialog(params.row)}
            >
              Create payment order
            </Button>
          </Stack>
      </Box>
    ),
  },
  actionFilter==='Approved'&&{
    field: "viewapprove",
    headerName: "View",
    flex: 1,
    minWidth: 200,
    renderCell:(params)=>(
      <Button variant="contained" size="small" onClick={()=>handleOpenPaymentView(params.row)}>
        View
      </Button>
    )

  },
  {
    field: "remarks",
    headerName: "Remarks",
    flex: 1,
    minWidth: 100,
    renderCell: (params) => (
      <Button variant="contained" color="primary" size="small" onClick={() => handleRemarksOpen(params.row)}>view</Button>
    )
  },
];

const PaymentCompletionTable = () => {
  const currentDate = new Date();
  const formattedDate = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}`;
  const [filters, setFilters] = useState({
    from_date: formattedDate,
    to_date: formattedDate,
    device: "",
  });
  const [actionFilter, setActionFilter] = useState("Pending");
  const [Data, setData] = useState(null)
  const [Page, setPage] = useState(1);
  const [IsLoading, setIsLoading] = useState(false)
  const [AlertMessage, setAlertMessage] = useState(null)
  const [AlertType, setAlertType] = useState("success")
  const [OpenAlert, setOpenAlert] = useState(false)
  const [ViewType, setViewType] = useState(null)
  const [Devices, setDevices] = useState(null)
  const [UserRole, setUserRole] = useState(null)

  const[OpenRemarks, setOpenRemarks] = useState(false)
  const [RemarksData, setRemarksData] = useState(null)


  // for po dialog

  const [Open, setOpen] = useState(false)
  const [SelectedRows, setSelectedRows] = useState(null)
  const [OpenPaymentOrder, setOpenPaymentOrder] = useState(false)


  // for complement payment dialog
  const [OpenPaymentDialog, setOpenPaymentDialog] = useState(false)
  const [PaymentType, setPaymentType] = useState(null)
  const [PaymentDialogData, setPaymentDialogData] = useState(null)
  const[PaymentData,setPaymentData] = useState(null)


  const handleOpenCompletePaymentDialog = (data) => {
    setPaymentDialogData(data)
    setOpenPaymentDialog(true)
    setPaymentType("create")
  }

  const handleOpenPaymentView=(data)=>{
    setPaymentData(data)
    setPaymentType("view")
    setOpenPaymentDialog(true)

  }

  const handleCloseCompletePaymentDialog = () => {
    setOpenPaymentDialog(false)
  }

  const handleRemarksOpen=(data)=>{
    setRemarksData(data)
    setOpenRemarks(true)
  }

  const handleCloseRemarks=()=>{
    setOpenRemarks(false)
  }



  const handleAlertOpen = (message, type) => {
    setAlertType(type)
    setAlertMessage(message)
    setOpenAlert(true)
  }


  const handleAlertClose = () => {
    setOpenAlert(false)
  }



  useEffect(() => {
    if (UserRole) {
      GetPaymentOrders(setIsLoading, handleAlertOpen, setData, Page, actionFilter, UserRole, filters)
    }
  }, [actionFilter, UserRole])


  useEffect(() => {
    GetUserRole("complete_payment", setIsLoading, setUserRole, handleAlertOpen)
    GetAllDevice(setIsLoading, setDevices, handleAlertOpen)

  }, [])


  const handleSearch = () => {
    if(UserRole){
    GetPaymentOrders(setIsLoading, handleAlertOpen, setData, Page, actionFilter, UserRole, filters)
    }
    else{
      handleAlertOpen("You are not authorized to view this page","error")
    }
  }

  const handleClear = () => {
    setFilters({
      from_date: formattedDate,
      to_date: formattedDate,
      device: "",
    })
    GetPaymentOrders(setIsLoading, handleAlertOpen, setData, Page, actionFilter, UserRole, {
      from_date: formattedDate,
      to_date: formattedDate,
      device: "",
    })
  }


  const handleChangePage = (page) => {
    setPage(page + 1)
    GetPaymentOrders(setIsLoading, handleAlertOpen, setData, page + 1, actionFilter, UserRole, filters)
  }


  // console.log("Data",Data);

  const filteredData = Data && Data.data && Array.isArray(Data.data) && Data.data.filter((row) => {
    return (

      (


        row

      )
    );
  });

  const handleViewPO = (row, type) => {
    setViewType(type)
    setSelectedRows(row)
    setOpen(true)
  };

  const handlePaymentOrderOpen = (row, type) => {
    setViewType(type)
    setSelectedRows(row)
    setOpenPaymentOrder(true)
  };

  const handlePaymentOrderClose = () => {
    setOpenPaymentOrder(false)
  };

  const handlePoClose = () => {
    setOpen(false)
  }

  const handleFilterChange = (key, value) => {
    setFilters((prevFilters) => ({ ...prevFilters, [key]: value }));
  };





  const exportToExcel = () => {
    console.log("filtered details",filteredData);
    
      const mappedData = filteredData.map(item => ({
        "Payment Order no": item.payment_order_id,
        "PO no": item.purchase_request_details
          .map(sub => sub.purchase_request_id)
          .join(", "),
        "Date":formatDate(item.created_at) ,
        "Brand Name": item.purchase_request_details
          .map(sub => sub.device_details.brand_name)
          .join(", "),
        "Device Name": item.purchase_request_details
          .map(sub => sub.device_details.name)
          .join(", "),
        "Model No": item.purchase_request_details
          .map(sub => sub.device_details.model)
          .join(", "),
        "Description": item.purchase_request_details
          .map(sub => sub.device_details.description)
          .join(", "),
        "Vendor's Name": item.purchase_order_details.vendor_details.vendor_name,
        "Quantity": item.purchase_request_details
          .map(sub => sub.quantity)
          .join(", "),
        "Total Amount": item.total_amount?item.total_amount:item.total_price?item.total_price:"",
        "PO Due Amount":item.due_amount,
        "Status": item.approval_status,
      }));
    
      const worksheet = XLSX.utils.json_to_sheet(mappedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Purchase Orders");
      XLSX.writeFile(workbook, "PurchaseOrders.xlsx");
    };

  console.log("filterdata", filteredData);


  return (
    <Box p={1} sx={{ minHeight: "100vh" }}>
      <RemarksDialog open={OpenRemarks} handleClose={handleCloseRemarks} data={RemarksData}/>
      <CompletePaymentDialog PaymentType={PaymentType} open={OpenPaymentDialog} handleClose={handleCloseCompletePaymentDialog} data={PaymentDialogData} viewData={PaymentData}/>
      <PaymentOrderDialog open={OpenPaymentOrder} handleClose={handlePaymentOrderClose} data={SelectedRows} type={ViewType} />
      <PurchaseOrderDialog open={Open} handleClose={handlePoClose} data={SelectedRows} type={ViewType} />
      <SnackBar open={OpenAlert} message={AlertMessage} type={AlertType} handleClose={handleAlertClose} />
      <BackdropLoader open={IsLoading} />
      
          {/* Enhanced Filter Section */}
          <Card variant="outlined" sx={{ padding: 2, marginBottom: 3 }}>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={3}>
                 <Typography variant='h5' sx={{color:"#20415C",marginBottom:1}} fontWeight={600} >From Date</Typography>
                <TextField
                  type="date"
                  variant="outlined"
                  size="small"

                  InputLabelProps={
                    {
                      shrink: true,
                    }
                  }

                  inputProps={
                    {
                      max:formattedDate
                    }
                  }

                  sx={{
                    '& .MuiOutlinedInput-root': {
                      border: '2px solid #A9A9A980 50%', // change border color
                      borderRadius: '8px',
                    },
                    '& fieldset': {
                        borderColor: '#A9A9A980', 
                        borderRadius:'8px'// default border color
                    },  
                  }}

                  value={filters.from_date}
                  onChange={(e) => handleFilterChange("from_date", e.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                 <Typography variant='h5' sx={{color:"#20415C",marginBottom:1}} fontWeight={600} >To Date</Typography>
                <TextField
                  type="date"
                  variant="outlined"
                  size="small"
                  InputLabelProps={
                    {
                      shrink: true,
                    }
                  }
                  inputProps={
                    {
                      max:formattedDate,
                      min:filters.from_date
                    }
                  }

                  sx={{
                    '& .MuiOutlinedInput-root': {
                      border: '2px solid #A9A9A980 50%', // change border color
                      borderRadius: '8px',
                    },
                    '& fieldset': {
                        borderColor: '#A9A9A980', 
                        borderRadius:'8px'// default border color
                    },  
                  }}
                  value={filters.to_date}
                  onChange={(e) => handleFilterChange("to_date", e.target.value)}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3} sx={{display:"none"}}>
                <Box sx={{ minWidth: 120 }}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">Device</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={filters.device}
                      onChange={(e) => handleFilterChange("device", e.target.value)}
                      label="Device"
                    >
                      {
                        Devices && Devices.map((device) => (
                          <MenuItem key={device._id} value={device._id}>
                            {device.bank_name + "-" + device.brand_name + "-" + device.name}
                          </MenuItem>
                        ))
                      }


                    </Select>
                  </FormControl>
                </Box>
              </Grid>
              <Grid item xs={12} md={1} mt={3.5}>
                <Button sx={{
                    backgroundColor:"#688B2A",
                    color:"#fff",
                    borderRadius:"10px",
                    '&:hover': {
                      backgroundColor: "#688B3A",
                      color:"#fff",
                      borderRadius:"10px",
                    },
                    }} variant="contained" color="primary" onClick={() => handleSearch()}>
                  Search
                </Button>
              </Grid>
              <Grid item xs={12} md={1} mt={3.5}>
                <Button sx={{borderRadius:"10px"}} variant="contained" color="secondary" onClick={() => handleClear()}>
                  Clear
                </Button>
              </Grid>

            </Grid>
          </Card>

          {/* Data Grid Section */}
          <SubCard title="Complete Payment" sx={{ marginTop: 1 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} mb={1}>
              {/* Filter Buttons */}
              <Box sx={{ display: "flex", gap: 2 }}>
                {["", "Approved", "Pending", "Rejected"].map((status) => (
                  <Button
                    key={status}
                    variant={actionFilter === status ? "contained" : "outlined"}
                    color={"secondary"}
                    onClick={() => setActionFilter(status)}
                    sx={{borderRadius:"8px"}}
                  >
                    {status === "" ? "All" : status}
                  </Button>
                ))}
              </Box>

              {/* Export to Excel Button */}
              <Button
                variant="outlined"
                color="primary"
                onClick={exportToExcel}
                startIcon={<FileDownloadIcon />}
              >
                Export to Excel
              </Button>
            </Box>
            <div style={{ height: 400, width: "100%" }}>
              {filteredData && filteredData.length > 0 ? (
                <DataGrid
                  rows={filteredData}
                  columns={columns(handleViewPO, handlePaymentOrderOpen, handleOpenCompletePaymentDialog,actionFilter,handleOpenPaymentView,handleRemarksOpen)}
                  initialState={{ pagination: { paginationModel: { page: Data ? Data.page : 0, pageSize: 9 } } }}
                  rowsPerPageOptions={[10]}
                  pageSize={10}
                  disableSelectionOnClick
                  rowHeight={100}
                  paginationMode="server"
                  scrollbarSize={8}
                  getRowId={(row) => row._id}
                  rowCount={Data && Data.total}
                  onPaginationModelChange={(params) => handleChangePage(params.page)}
                  components={{
                    NoRowsOverlay: () => (
                      <Box sx={{ textAlign: "center", color: "#888", padding: 2 }}>
                        <Typography variant="body1">No matching records found.</Typography>
                      </Box>
                    ),
                  }}
                  sx={{
                    "& .MuiDataGrid-root": {
                      borderRadius: "8px", // Added border radius for smoother design
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: "#F8FAFC",
                      color: "#592375",
                      fontWeight: "bold",
                      textTransform: "uppercase", // Text in headers becomes uppercase
                    },
                    "& .MuiDataGrid-cell": {
                      padding: "10px", // Slightly increased padding for readability
                    },
                    "& .MuiDataGrid-row:nth-of-type(odd)": {
                      backgroundColor: "#F6F6F6",
                    },
                    "& .MuiDataGrid-row:hover": {
                      backgroundColor: "#e0f7fa", // Light blue hover effect
                      cursor: "pointer",
                    },
                    "& .MuiDataGrid-footerContainer": {
                      backgroundColor: "#f8f9fa", // Light footer background for pagination
                    },
                  }}
                />
              ) : (
                <Typography variant="body1" align="center">
                  No data available.
                </Typography>
              )}
            </div>
          </SubCard>





       

      {/* Snackbar for Notifications */}

    </Box>
  );
};

export default PaymentCompletionTable;

